import React from 'react';
import ReportEmpty from 'assets/report_empty.svg';

const EmptyState = () => {
  return (
    <div
      className="bg-white flex flex-col items-center justify-center h-full rounded-lg"
      style={{
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
        padding: '96px'
      }}
      data-testid="reports-empty-state"
    >
      <div
        className="overflow-hidden flex items-center justify-center mb-2"
        style={{ height: '250px', width: '502px' }}
      >
        <img
          src={ReportEmpty}
          alt="Select Report Illustration"
          className="max-w-full max-h-full"
        />
      </div>
      <div className="text-center flex flex-col" style={{ gap: '8px' }}>
        <p
          className="font-semibold text-neutral-1000"
          style={{
            fontSize: '14px',
            lineHeight: '20px'
          }}
        >
          Select Report
        </p>
        <p
          className="font-normal text-neutral-1000"
          style={{
            fontSize: '14px',
            lineHeight: '20px',
            maxWidth: '411px'
          }}
        >
          Select a report type from the list on the left to generate a report
          based on your data
        </p>
      </div>
    </div>
  );
};

export default EmptyState;
